/**
 * One canvas for the whole app rather than one per frame: `measureTextPt` sets `font` and
 * `letterSpacing` before every `measureText`, so the context carries no state between calls.
 */
let sharedMeasureCanvas: HTMLCanvasElement | null = null

export function measureContext(): CanvasRenderingContext2D | null {
  if (typeof document === 'undefined') return null
  if (!sharedMeasureCanvas) sharedMeasureCanvas = document.createElement('canvas')

  return sharedMeasureCanvas.getContext('2d')
}

/** Exposes the same shared canvas context `measureTextPt` measures with, so a downstream stage
 *  (drop-cap font-size/advance solving) rasterizes glyphs against identical canvas state rather
 *  than a context of its own — the same "measure with the engine that draws" reasoning this
 *  module's header already applies to `measureTextPt` itself. */
export function getSharedMeasureContext(): CanvasRenderingContext2D | null {
  return measureContext()
}
